/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * The footer component of TableReportsSubsciber
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { FC } from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button } from '@components/common';
import { TableFooterContainerStyled } from '@components/common/TableFooter';
import { TableFooterOpenHandlerStyled } from '@components/common/TableFooter/styled/TableFooterStyled';
import ArrowTooltip from '@components/common/Tooltip/Tooltip';
import { EGTMBasketSectionType, EGTMBasketValueType } from '@modules/analytics/GoogleTagManager/GTMOperations/GTMBasketOperations';
import { makeSelectTranslationCommon, makeSelectTranslationPageSubscriberMobile } from '@modules/internationalization/intSelectors';
import { useBasketModalOpen } from '@modules/table/components/Basket/Modal/useBasketModalOpen';
import { tableBasketCountSelector } from '@modules/table/selectors';
import { RoutePath } from '@routes/constants/routesConstants';

import { IReportsConstructorLocationData } from '../../PageReportsConstructor/types';
import { TableReportsSubscriberFooterStyled } from './styled/TableReportsSubscriberStyled';

export const TableReportsSubscriberFooter: FC = () => {
    const history = useHistory<IReportsConstructorLocationData>();

    const { tableFooter: tTableFooter } = useSelector(makeSelectTranslationPageSubscriberMobile());
    const { basket: tBasket } = useSelector(makeSelectTranslationCommon());

    const basketCount = useSelector(tableBasketCountSelector);

    const { open: openBasketModal } = useBasketModalOpen({
        gtm: {
            sectionType: EGTMBasketSectionType.MOBILE,
            valueType: EGTMBasketValueType.NUMBER,
        },
    });

    const handleSave = () => {
        history.push(RoutePath.reportsConstructor);
    };

    return (
        <TableFooterContainerStyled>
            {!!basketCount && (
                <TableFooterOpenHandlerStyled
                    style={{ left: 40 }}
                    onClick={() => openBasketModal(tTableFooter.basketTitle)}
                >
                    {tBasket.checkedNum} {basketCount}
                </TableFooterOpenHandlerStyled>
            )}
            <TableReportsSubscriberFooterStyled>
                <ArrowTooltip
                    disableHoverListener={!!basketCount}
                    title={tTableFooter.confirmButtonTooltip}
                >
                    <span>
                        <Button
                            disabled={!basketCount}
                            onClick={handleSave}
                        >
                            {tTableFooter.confirmButton}
                        </Button>
                    </span>
                </ArrowTooltip>
            </TableReportsSubscriberFooterStyled>
        </TableFooterContainerStyled>
    );
};
